import React, { useState, useContext } from 'react';
import { SimpleStorageContext } from '../../context/simpleStorage/simpleStorageContext';
import Swal from 'sweetalert2';

const extractYouTubeVideoId = (url) => {
    const patterns = [
        /(?:youtube\.com\/watch\?v=)([^&]+)/,
        /(?:youtu\.be\/)([^?]+)/,
        /(?:youtube\.com\/embed\/)([^?]+)/
    ];

    for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match && match[1]) {
            return match[1];
        }
    }

    return null;
};

const validateYouTubeUrl = (url) => {
    const patterns = [
        /^https?:\/\/(www\.)?youtube\.com\/watch\?v=[\w-]+/,
        /^https?:\/\/youtu\.be\/[\w-]+/,
        /^https?:\/\/(www\.)?youtube\.com\/embed\/[\w-]+/
    ];

    return patterns.some(pattern => pattern.test(url));
};

function VideosForm({ idCasa, onAddComplete, entityCode }) {
    const [videoUrl, setVideoUrl] = useState('');

    const { addVideo, loading } = useContext(SimpleStorageContext);

    const handleAddVideo = async () => {
        if (!videoUrl.trim()) {
            Swal.fire('Error', 'Debes ingresar una URL de YouTube', 'warning');
            return;
        }

        if (!validateYouTubeUrl(videoUrl)) {
            Swal.fire('Error', 'La URL ingresada no es válida. Debe ser de YouTube', 'error');
            return;
        }

        const videoId = extractYouTubeVideoId(videoUrl);
        if (!videoId) {
            Swal.fire('Error', 'No se pudo extraer el ID del video', 'error');
            return;
        }

        if (!idCasa) {
            Swal.fire('Error', 'ID de propiedad no válido', 'error');
            return;
        }

        try {
            await addVideo({
                idCasa,
                external_url: videoUrl,
                userFilename: `youtube_${videoId}`,
                entityCode
            });

            Swal.fire('Listo', 'Video agregado correctamente', 'success');
            setVideoUrl('');
            if (onAddComplete) {
                onAddComplete();
            }
        } catch (error) {
            Swal.fire('Error', 'No se pudo agregar el video', 'error');
        }
    };

    return (
        <div>
            <div className='form-group'>
                <label htmlFor='video-url' className='form-label'>
                    YouTube URL
                </label>
                <input
                    type='text'
                    className='form-control'
                    id='video-url'
                    placeholder='https://www.youtube.com/watch?v=...'
                    value={videoUrl}
                    onChange={(e) => setVideoUrl(e.target.value)}
                    disabled={loading}
                />
                <small className='form-text text-muted'>
                    Pega la URL completa del video de YouTube
                </small>
            </div>
            <button
                type='button'
                className='btn btn-primary btn-block w-100 mt-2'
                onClick={handleAddVideo}
                disabled={loading || !videoUrl.trim()}
            >
                {loading ? 'Agregando...' : 'Agregar Video'}
            </button>
        </div>
    );
}

export default VideosForm;
